import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import {withStyles, Slide} from '@material-ui/core';
import GoogleMapReact from 'google-map-react';
import Place from '@material-ui/icons/Place';
import {styles} from './styles';
 
const MarkerComponent = ({content}) => <div>{content}</div>;
MarkerComponent.propTypes = {
  content: PropTypes.object.isRequired
};

const Transition = (props) => {
  return <Slide direction="up" {...props} />;
};

class DialogMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lat: 21.062302,
      long: -89.611489,
      refresh: false
    };
    this.selectPosition = this.selectPosition.bind(this);
    this.successActionMap = this.successActionMap.bind(this);
  }

  selectPosition(e) {
    const {movePiker} = this.props;
    if (movePiker) {
      this.setState({lat: e.lat, long: e.lng, refresh: true});
    }
  }

  successActionMap() {
    this.props.successAction({...this.state});
  }

  render() {
    const {classes, isOpen, closeDialog, successAction, closeText, title} = this.props;
    let {lat, long} = this.props;
    const {refresh} = this.state;
    if ((!lat && !long) || refresh) {
      lat = this.state.lat;
      long = this.state.long;
    } 
    return isOpen && (
      <div>
        <Dialog
          fullScreen
          disableBackdropClick 
          disableEscapeKeyDown 
          open={isOpen}
          onClose={this.closeDialog} 
          TransitionComponent={Transition} 
          className={classes.muiDialog}
        >
          <DialogTitle>{title || 'Ubicación'}</DialogTitle>
          <DialogContent >
            <div className={classes.mapContainer} > 
              <GoogleMapReact
                bootstrapURLKeys={{key: 'AIzaSyCRlpd9z_60R4K_R4QVBENJ6D3jZbLfU94'}}
                defaultCenter={{
                  lat,
                  lng: long 
                }}
                defaultZoom={12}
                options={{fullscreenControl: false}}
                onClick={this.selectPosition}
              >
                <MarkerComponent
                  lat={lat}
                  lng={long}
                  content={<Place className={classes.markerTrivo} color="secondary" fontSize="large" />}
                />
              </GoogleMapReact>
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={closeDialog} color="primary">
              {closeText || 'Cancelar'}
            </Button>
            {successAction && 
            <Button onClick={this.successActionMap} variant="contained" color="primary">
              Guardar
            </Button> 
            } 
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
DialogMap.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  closeDialog: PropTypes.func.isRequired,
  successAction: PropTypes.func,
  closeText: PropTypes.string,
  title: PropTypes.string,
  movePiker: PropTypes.bool,
  lat: PropTypes.number,
  long: PropTypes.number
};

export default (withStyles(styles)(DialogMap));
